import { useRef, useState } from 'react'

import { Text } from 'components/atoms/text'
import { useIntl } from 'react-intl'
import { copyToClipboard } from 'utils/copyToClipboard'

import { StyledPopup } from './index.styled'

export type Props = {
  className?: string
  shareUrl: string
  show: boolean
  onHidden?: () => void
}

const SharePopup = ({ shareUrl = '', show, onHidden }: Props) => {
  const { formatMessage: f } = useIntl()
  const [showCopiedMessage, setShowCopiedMessage] = useState<boolean>(false)

  const timer = useRef<NodeJS.Timeout | null>(null)
  const onCopyCallback = () => {
    setShowCopiedMessage(true)

    if (timer.current) {
      clearTimeout(timer.current)
    }

    timer.current = setTimeout(() => {
      setShowCopiedMessage(false)
    }, 3000)
  }

  const socialList: { icon: string; name: string; href: string }[] = [
    {
      icon: '/icons/facebook.svg',
      name: 'Facebook',
      href: `https://www.facebook.com/sharer.php?u=${shareUrl}`,
    },
    {
      icon: '/icons/zalo.png',
      name: 'Zalo',
      href: `https://sp.zalo.me/share?href=${shareUrl}`,
    },
    {
      icon: '/icons/twitter.svg',
      name: 'Twitter',
      href: `https://twitter.com/intent/tweet?url=${shareUrl}`,
    },
    {
      icon: '/icons/linkedin.svg',
      name: 'LinkedIn',
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`,
    },
    {
      icon: '/icons/messenger.svg',
      name: 'Messenger',
      href: `https://www.facebook.com/sharer.php?u=${shareUrl}`,
    },
  ]

  return (
    <StyledPopup
      isOpen={show}
      type="due-date"
      onClose={onHidden}
      closeIcon={<img loading="lazy" src="/images/close.svg" alt="" />}
      id="share-popup"
    >
      <div className="header">
        <Text type="subtitle-1">{f({ id: 'community.share' })}</Text>
      </div>
      <div className="share__content-wrapper">
        <Text type="bodytext-2">{f({ id: 'article.shareOn' })}</Text>
        <div className="social-links">
          {socialList.map((s, i) => (
            <a
              href={s.href}
              target="_blank"
              key={i}
              className="social-container"
            >
              <img loading="lazy" src={s.icon} alt={s.name} />
              <Text type="bodytext-3">{s.name}</Text>
            </a>
          ))}
        </div>
        <div className="onclick-copy">
          <Text type="subtitle-2">
            {f({
              id: showCopiedMessage
                ? 'authorPage.share.copiedButton'
                : 'article.copyLink',
            })}
          </Text>
          <img
            loading="lazy"
            src="/icons/copy_line.svg"
            alt="copy"
            onClick={() => {
              copyToClipboard(shareUrl)
              onCopyCallback()
            }}
          />
        </div>
      </div>
    </StyledPopup>
  )
}

export { SharePopup }
